import { render, staticRenderFns } from "./RecordingsPage.vue?vue&type=template&id=793300ba&"
import script from "./RecordingsPage.vue?vue&type=script&lang=js&"
export * from "./RecordingsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports